<template>
	<div 
		class="log-tile" 
		:class="{
			reviewable: job.reviewable, 
			'has-transfer-pending': logHasPendingTransfers, 
			'reviewed':dayLog.reviewed_by>0
		}" 
		v-on:click="editTimeLog(dayLog,job.reviewable)">

		<span v-if="logHasPendingTransfers" class="warning-icon"><i class="fa fa-exclamation-triangle"></i></span>

		<span v-if="job.reviewable" class="float-right edit-icon"><i class="fa fa-pencil-alt"></i></span>
		<span v-else class="float-right"><i class="fa fa-lock"></i></span>

		{{dayLog.timeOnlyIn}} to {{dayLog.timeOnlyOut}} ({{dateDiff(dayLog.time_in,dayLog.time_out,'hrs')}} hrs)

		<ul style="padding-left: 25px;margin-bottom: 5px;">
			<li v-if="dayLog.regular_hours > 0">Reg: {{dayLog.regular_hours}}</li>
			<li v-if="dayLog.overtime_hours_15x > 0">OT 1.5x: {{dayLog.overtime_hours_15x}}</li>
			<li v-if="dayLog.overtime_hours_2x > 0">OT 2x: {{dayLog.overtime_hours_2x}}</li>
			<li v-if="dayLog.overtime_hours_25x > 0">OT 2.5x: {{dayLog.overtime_hours_25x}}</li>
		</ul>

		<div v-if="dayLog.clocked_in_offsite == 1" class="text-danger">
			<i class="fa fa-map-marker"></i>
			Clocked in offsite
		</div>
		<div v-if="dayLog.clocked_out_offsite == 1" class="text-danger">
			<i class="fa fa-map-marker"></i>
			Clocked out offsite
		</div>
		<div v-if="dayLog.no_location_clockin == 1" class='text-danger'>
			<i class="fa fa-dot-circle"></i>
			Location failed - Clock In
		</div>
		<div v-if="dayLog.no_location_clockout == 1" class='text-warning'>
			<i class="fa fa-dot-circle"></i>
			Location failed - Clock Out
		</div>

		<div v-if="dayLog.PayBoost.length > 0">
			Claimed
			<span v-for="(boost,index) in dayLog.PayBoost">
				{{boost.description}}<template v-if="index + 1 < dayLog.PayBoost.length">, </template>
			</span>
		</div>

		<small v-if="logHasPendingTransfers">OT Transfer to review</small>

		<div v-if="dayLog.reviewed_by > 0" class="reviewed-tag">
			
			<span class="reviewed-icon" title="Time Log has been reviewed"><i class="fa fa-check"></i></span>
			Reviewed
		</div>

		<!--<button class="btn btn-light btn-sm edit-button"><i class="fa fa-pencil"></i> Edit</button>-->
		
	</div>
</template>

<script type="text/javascript">
export default {
	name: "TimeLogReviewTile",
	props: ["dayLog","job","logHasPendingTransfers"],
	methods: {
		editTimeLog() {
			this.$emit("edit")
		}
	}
}
</script>

<style type="text/css" scoped>
	
	.log-tile {
		min-width: 110px;
		margin: 0;
		margin-top: 1px;
		margin-bottom: 1px;
		margin-left: -3px;
		margin-right: -3px;
		padding:5px;
		font-size:10pt;
		position: relative;
		background-color: #eff6ff;
		border: 1px solid #ced5ea;
		
		border-radius: 5px;
	}

	.log-tile.reviewed {
		background-color: #f3ffef;
		border: 1px solid #d5eace;
	}

	.log-tile .edit-button {
		position: absolute;
		left: calc(50% - 28px);
		top: calc(50% - 15px);
		display: none;
	}

	.log-tile:hover .edit-button {
		display: block;
	}

	.log-tile.reviewable:hover {
		/*background-color: #d5eace;*/
		cursor: pointer;
	}

	.log-tile.has-transfer-pending {
		background-color: #ffefef;
		border: 1px solid #eacece; 
	}

	.log-tile.reviewable.has-transfer-pending:hover {
		background-color: #eacece;
		cursor: pointer;
	}

	.edit-icon {
		display: none;
	}

	.log-tile.reviewable:hover .edit-icon {
		display: initial;
		position: absolute;
		top: 3px;
		right: 5px;
	}

	.log-tile.reviewable:hover .warning-icon {
		display: none;
	}

	.reviewed-tag {
		text-align: right;
	}

	/*.reviewed-icon {
		position: absolute;
		bottom: 3px;
		right: 5px;
	}*/

</style>